import React from 'react';
import { 
  RocketLaunchIcon,
  MagnifyingGlassIcon,
  WrenchScrewdriverIcon,
  CogIcon
} from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import StageCards from '../../../components/playbooks/StageCards';
import { getPlaybookById } from '../../../data/playbookTaxonomy';

const HowToExecute = () => {
  const playbook = getPlaybookById('leverage-ai-for-you-and-your-org');
  
  // Filter out non-stage sections for StageCards
  const stages = playbook.sections.filter(section => 
    section.id.startsWith('stage-')
  );

  // Define stage icons mapping
  const stageIcons = {
    'stage-1': <MagnifyingGlassIcon className="h-7 w-7 text-primary-light" />,
    'stage-2': <WrenchScrewdriverIcon className="h-7 w-7 text-primary-light" />,
    'stage-3': <CogIcon className="h-7 w-7 text-primary-light" />
  };

  const introText = `
    This playbook takes a practical, hands-on approach to AI adoption that prioritizes speed over perfection. 
    Rather than getting bogged down in policies and procedures, you'll learn by doing - identifying real opportunities, 
    building actual tools, and creating momentum through visible wins.
  `;

  return (
    <PlaybookSection
      title="How To Execute"
      icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />}
      heading="3-Stage Approach to AI Adoption"
    >
      <div className="prose prose-invert max-w-none">
        <p className="text-lg text-gray-300 leading-relaxed mb-8">
          {introText}
        </p>

        <div className="mb-8">
          <h3 className="text-xl font-semibold text-white mb-4">Our Philosophy</h3>
          <div className="bg-gray-800/50 rounded-lg p-6 border border-gray-700/50">
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-start">
                <span className="text-primary-light mr-3">—</span>
                <span><strong className="text-white">Start where it hurts:</strong> Focus on the most painful, repetitive tasks first</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-light mr-3">—</span>
                <span><strong className="text-white">Build momentum through visibility:</strong> Share wins publicly to encourage adoption</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-light mr-3">—</span>
                <span><strong className="text-white">Empower, don't police:</strong> Create guardrails, not barriers</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-light mr-3">—</span>
                <span><strong className="text-white">Iterate based on real usage:</strong> Let practice inform policy, not the other way around</span>
              </li>
            </ul>
          </div>
        </div>

        <StageCards 
          stages={stages}
          icons={stageIcons}
          playbookId="leverage-ai-for-you-and-your-org"
          introText="Follow these three stages to systematically introduce and scale AI across your organization:"
        />

       
      </div>
    </PlaybookSection>
  );
};

export default HowToExecute; 